import { css } from "@emotion/react";
import { memo } from "react";
import { artistList, teamList } from "../../../consts";
import { pageCSS } from "../../templates/PageTemplate";

const Artist = () => {
  return (
    <div
      id="artists"
      css={css`
        background-image: url(/img/bg.jpg);
        background-color: #fff;
      `}
    >
      <div
        css={css`
          padding: 100px;
          max-width: 860px;
          margin: 0 auto;
          padding: 120px 40px 40px;
        `}
      >
        <h2
          css={[
            pageCSS.titleStyle,
            css`
              text-align: left;
            `,
          ]}
        >
          YOKAI ARTISTS
        </h2>
        <div>
          <ul
            css={css`
              font-family: "Bebas Neue", cursive;
              font-size: 18px;
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              padding: 0;
              gap: 12px;
            `}
          >
            {artistList.map((artist) => (
              <li
                key={artist.img}
                css={css`
                  width: 15%;
                  display: inline-block;
                  text-align: center;

                  @media screen and (max-width: 1024px) {
                    width: auto;
                  }
                `}
              >
                <a
                  href={artist.link !== "" ? artist.link : undefined}
                  target={"_blank"}
                  rel="noreferrer noopener"
                  css={[
                    css`
                      color: #000;
                      text-decoration: none;
                      transition: opacity 0.3s;
                      &:hover {
                        opacity: 0.5;
                      }
                    `,
                    artist.link !== ""
                      ? null
                      : css`
                          &:hover {
                            opacity: 1;
                          }
                        `,
                  ]}
                >
                  <img
                    css={css`
                      width: 100px;
                      min-width: 100px;
                      margin: 0 auto;
                    `}
                    src={`/img/artist/${artist.img}.png`}
                    alt={artist.name}
                  />
                  <span>{artist.name}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div id="team">
        <div
          css={css`
            padding: 100px;
            max-width: 860px;
            margin: 0 auto;
            padding: 100px 40px 120px;
          `}
        >
          <h2
            css={[
              pageCSS.titleStyle,
              css`
                text-align: left;
              `,
            ]}
          >
            Gen Art Artist
          </h2>
          <div>
            <ul
              css={css`
                font-family: "Bebas Neue", cursive;
                font-size: 18px;
                display: flex;
                flex-wrap: wrap;
                padding: 0;
                gap: 12px;
              `}
            >
              {teamList.map((member) => (
                <li
                  key={member.name}
                  css={css`
                    width: 15%;
                    display: inline-block;
                    text-align: center;
                  `}
                >
                  <a
                    href={member.link}
                    target={"_blank"}
                    rel="noreferrer noopener"
                    css={[
                      css`
                        color: #000;
                        text-decoration: none;
                        transition: opacity 0.3s;
                        &:hover {
                          opacity: 0.5;
                        }
                      `,
                    ]}
                  >
                    <img
                      css={css`
                        width: 100px;
                        min-width: 100px;
                        margin: 0 auto;
                      `}
                      src={`/img/${member.img}.png`}
                      alt={member.name}
                    />
                    <span>{member.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(Artist);
